import { IServiceInfo } from "../domain/conciliator.entity";
import { conciliatorGateway } from "../domain/conciliator.gateway";

export class GetServiceInfoUseCase {
  constructor(private gateway: conciliatorGateway) {}

  async execute(): Promise<IServiceInfo[]> {
    return await this.gateway.getServiceInfo();
  }
}
